import "./App.css";
 
import "./responsive.css";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import { useEffect } from "react";
import { isTokenExpired } from "./utils/TokenUtils";

import Login from "./components/login/Login";
import Register from "./components/register/Register";
import ResetNewPassword from "./components/resetNewPassword/ResetNewPassword";
import Home from "./pages/home/Home";
import ForgotPassword from "./components/forgotPassword/ForgotPassword";
import Products from "./pages/producsts/Products";
import AboutUs from "./pages/about/About";
import PrivacyPolicy from "./pages/privacyPolicy/PrivacyPolicy";
import ContactUs from "./pages/contactus/ContactUs";
import ProductsListing from "./pages/productsListing/ProductsListing";
import ProductsDetails from "./pages/productsDetails/ProductsDetails";
import Error from "./pages/error/Error";
import Profile from "./pages/profile/Profile";
import ProfileUpdate from "./pages/profileUpdate/ProfileUpdate";
import CartItem from "./pages/cart/Cart";
import Wishlist from "./pages/wishlist/Wishlist";
import OrderTracking from "./pages/orderTracking/OrderTracking";
import Subcategories from "./pages/subcategories/Subcategories";
import PopularProducts from "./components/productsSubcategory/ProductsSubcategory";
import { WishlistProvider } from "./context/WishlistContext";
import { CartProvider } from "./context/CartContext";
import BuyNowAddress from "./pages/buynowaddress/BuyNowAddress";
import RazorpayButton from "./RazorpayButton";
import Return from "./pages/return/Return";
import SearchProductList from "./pages/searchProductList/SearchProductList";
import BuyNowCartAddress from "./pages/buynowcartaddress/BuyNowCartAddress";
import OrderSuccessfull from "./components/ordersuccessfull/OrderSuccessfull";
import MyOrder from "./pages/myorder/MyOrder";
import ResizeWebsite from "./components/resizewebsite/ResizeWebsite";
import Dishpatch from "./pages/dishpatch/Dishpatch";
import SubcategoryProducts from "./pages/subcategoryproducts/SubcategoryProducts";
 

function App() {
  const navigate = useNavigate();
  const location = useLocation();

 
  const isAuthRoute = [
    "/login",
    "/register",
    "/forgotpassword",
    "/resetpassword",
  ].includes(location.pathname);

 useEffect(() => {
  const token = localStorage.getItem("authToken");

  if (!isAuthRoute && token && isTokenExpired(token)) {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");

    Swal.fire({
      icon: "warning",
      title: "Session Expired",
      text: "Your session has expired. Please log in again.",
      confirmButtonText: "OK",
    }).then(() => {
      navigate("/login");
    });
  }
}, [location, navigate]);

  return (
    <div className="App">
      <ResizeWebsite />
      <WishlistProvider >
        <CartProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/resetpassword" element={<ResetNewPassword />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
           <Route path="/return" element={<Return />} />
          <Route path="/products" element={<Products />} />
          <Route path="/productslisting" element={<ProductsListing />} />
          <Route path="/product-details/:id" element={<ProductsDetails />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/updateprofile" element={<ProfileUpdate />} />
          <Route path="/cart" element={<CartItem />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/ordertracking" element={<OrderTracking />} />
          <Route path="/subcategories/:id" element={<Subcategories />} />
          <Route path="/subcategoriesproducts/:subcategoryId" element={<SubcategoryProducts />} />
          <Route path="/products/category/:id" element={<PopularProducts />} />
          <Route path="/buynowaddress" element={<BuyNowAddress />} />
          <Route path="/buynowcartaddress" element={<BuyNowCartAddress />} />
          <Route path="/searchproductlist" element={<SearchProductList /> } />
          <Route path="/ordersuccess" element={<OrderSuccessfull /> } />
          <Route path="/myorder" element={<MyOrder />} />
          <Route path="/resizewebsite" element={<ResizeWebsite />} />
          <Route path="/trackorder/:orderId" element={<Dishpatch />} />
          
          
          <Route path="/razorpay" element={<RazorpayButton />} />
          
          <Route path="*" element={<Error />} />
        </Routes>
        </CartProvider>
      </WishlistProvider>
    </div>
  );
}

export default App;
